import dayjs from 'dayjs';
import {
  CurrentSubscriberFieldsFragment,
  GroupingUnitType,
  IntegrationFieldsFragment,
  IntegrationType,
} from '@generated/types';

const fillMissingChartData = (
  key: string | number | symbol,
  dataArray: any[],
  metrics: dayjs.Dayjs[],
  groupingUnit: GroupingUnitType
): any[] => {
  const newArray = metrics.map(date => {
    const matchingDate = dataArray.find(
      // @ts-expect-error - (This is for the groupingUnit enum)
      d => Math.abs(dayjs(d.timepoint).diff(date, groupingUnit.toLowerCase())) === 0
    );
    if (matchingDate) {
      return matchingDate;
    }
    return { [key]: 0 };
  });
  return newArray;
};

export function mapArrayObjToArrayKeyValues<T, K extends keyof T>(
  dataArray: T[],
  keys: K[],
  metrics: dayjs.Dayjs[],
  groupingUnit: GroupingUnitType
): {
  [propName: string]: number[];
} {
  return keys.reduce((total, key: K) => {
    const newArr = fillMissingChartData(key, dataArray, metrics, groupingUnit);
    const mapArray: T[K][] = newArr.map<T[K]>((t: T) => t[key]);
    const keyName = key + 'Metric';

    return {
      ...total,
      [keyName]: mapArray,
    };
  }, {});
}

export const sum = (dataArray: number[]): number => {
  return dataArray.length ? dataArray.reduce((prev: number, curr: number) => prev + curr, 0) : 0;
};

export const isGlobalAdmin = (currentSubscriber?: CurrentSubscriberFieldsFragment): boolean =>
  !!currentSubscriber?.role?.permissions.find(permission => permission.key === 'global.any.own');

export function nFormatter(num: number, digits = 0): string {
  const symbols = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
  ];

  if (num < 1) return num.toString();
  const regex = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const i = symbols.reverse().findIndex(s => num >= s.value);
  return (num / symbols[i].value).toFixed(digits).replace(regex, '$1') + symbols[i].symbol;
}

export const isUrl = (val: string): boolean =>
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(
    val
  );

const integrationsWithIdentityProvider = [
  IntegrationType.FACEBOOK_APP,
  IntegrationType.OPEN_ID_CONNECT,
];

export const getEnabledIdentityProviders = (
  integrations: IntegrationFieldsFragment[]
): IntegrationType[] =>
  integrations
    .filter(
      integration =>
        integration.enabled && integrationsWithIdentityProvider.includes(integration.type)
    )
    .map(integration => integration.type);
